import { useEffect, useState } from "react";
import { TextInput } from "./Field";

/**
 * The "Order" box: a whole number from 1 that ranks a request within its
 * priority, or empty for "not ordered". Commits on blur or Enter, and only
 * when the value actually changed; Escape puts the saved value back. A value
 * that is not a whole number from 1 is dropped rather than sent.
 */
export function OrderInput({
  value,
  onCommit,
  ariaLabel,
  disabled,
  className = "",
}: {
  value: number | null;
  onCommit: (order: number | null) => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}) {
  const saved = value === null ? "" : String(value);
  const [draft, setDraft] = useState(saved);
  useEffect(() => setDraft(saved), [saved]);

  const commit = () => {
    const text = draft.trim();
    if (text === "") {
      if (value !== null) onCommit(null);
      return;
    }
    const n = Number(text);
    if (!Number.isInteger(n) || n < 1) {
      setDraft(saved); // not an order; forget it
      return;
    }
    if (n !== value) onCommit(n);
  };

  return (
    <TextInput
      type="number"
      inputMode="numeric"
      min={1}
      step={1}
      aria-label={ariaLabel}
      value={draft}
      disabled={disabled}
      placeholder="—"
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") (e.target as HTMLInputElement).blur();
        if (e.key === "Escape") {
          setDraft(saved);
          (e.target as HTMLInputElement).blur();
        }
      }}
      className={className}
    />
  );
}
